import React, { useRef, useState } from "react";
import * as styles from "./FloorPlans.module.css";
import dotsIcon from "../../../images/on-going-projects/enchanted/Icons/dots-icon.png";
import floorPlanImage1 from "../../../images/on-going-projects/enchanted/floor-plan-1.jpg";
import floorPlanImage2 from "../../../images/on-going-projects/enchanted/floor-plan-2.jpg";
import BrochureModal from "./BrochureModal";
import brochurePdfUrl1 from "../../../images/on-going-projects/enchanted/1-4-brochure-pdf.pdf";
import brochurePdfUrl2 from "../../../images/on-going-projects/enchanted/5-6-brochure-pdf.pdf";

function FloorPlans() {
  const floorPlan1Ref = useRef(null);
  const floorPlan2Ref = useRef(null);
  const [selectedFloorPlan, setSelectedFloorPlan] = useState(null);
  const [showBrochureModal, setShowBrochureModal] = useState(false);

  const handleFloorPlan1Click = () => {
    setShowBrochureModal(true);
    setSelectedFloorPlan(1);
  };

  const handleFloorPlan2Click = () => {
    setShowBrochureModal(true);
    setSelectedFloorPlan(2);
  };

  return (
    <section className={styles.floorPlansContainer} id="floor-plans">
      <h1>
        <img loading="lazy"  src={dotsIcon} alt="dots-icon" className={styles.dotsIcon} />
        Floor Plans
      </h1>
      <div className={styles.floorPlansImagesContainer}>
        <a style={{ display: 'none' }} ref={floorPlan1Ref} href={brochurePdfUrl1} download>
        </a>
        <img loading="lazy"  src={floorPlanImage1} alt="floor-plan-image-1" onClick={handleFloorPlan1Click} />
        <a style={{ display: 'none' }} ref={floorPlan2Ref} href={brochurePdfUrl2} download>
        </a>
        <img loading="lazy"  src={floorPlanImage2} alt="floor-plan-image-2" onClick={handleFloorPlan2Click} />
      </div>
      <BrochureModal 
        brochurePdfUrlRef={selectedFloorPlan === 1 ? floorPlan1Ref : floorPlan2Ref}
        showBrochureModal={showBrochureModal}
        setShowBrochureModal={setShowBrochureModal} />
      </section>
  );
}

export default FloorPlans;
